<section class="vc-admin-global-pricing">
  <header class="vc-admin-global-pricing__header">
    <h3>{{ 'ADMIN.CUSTOMERS.PRICING_GLOBAL.TITLE' | translate }}</h3>
    <p>{{ 'ADMIN.CUSTOMERS.PRICING_GLOBAL.DESCRIPTION' | translate }}</p>
  </header>

  <div class="vc-admin-global-pricing__filters">
    <span class="vc-admin-global-pricing__currency-chip">EUR</span>

    <button pButton type="button" icon="pi pi-save" [disabled]="saving" (click)="save()">
      {{ 'COMMON.SAVE' | translate }}
    </button>
  </div>

  @if (loading) {
    <p class="vc-admin-global-pricing__state">{{ 'COMMON.LOADING' | translate }}</p>
  } @else if (!rows.length) {
    <div class="vc-admin-global-pricing__empty">
      <strong>{{ 'ADMIN.CUSTOMERS.PRICING_GLOBAL.EMPTY.TITLE' | translate }}</strong>
      <p>
        {{
          (loadFailed
            ? 'ADMIN.CUSTOMERS.PRICING_GLOBAL.EMPTY.LOAD_ERROR'
            : 'ADMIN.CUSTOMERS.PRICING_GLOBAL.EMPTY.NO_ITEMS')
            | translate
        }}
      </p>
      <button pButton type="button" icon="pi pi-refresh" [disabled]="loading" (click)="load()">
        {{ 'COMMON.RETRY' | translate }}
      </button>
    </div>
  } @else {
    <p-table [value]="rows" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'ADMIN.CUSTOMERS.PRICING_GLOBAL.CONCEPT' | translate }}</th>
          <th>{{ 'ADMIN.CUSTOMERS.PRICING_GLOBAL.MONTHLY_PRICE' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ getConceptLabel(row) }}</td>
          <td>
            <p-inputNumber
              [(ngModel)]="row.monthly_price"
              mode="decimal"
              [min]="0"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
            ></p-inputNumber>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
